import Vue from 'vue';
import VueRouter from 'vue-router';
import Products from '@/pages/Products';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import ProductsDetail from '@/pages/Products/Detail';
import Services from '@/pages/Services';
import Admin from '@/pages/Admin';
import AdminHome from '@/pages/Admin/Project';
import AdminProductType from '@/pages/Admin/ProductType';
import TurnkeyProjects from '@/pages/TurnkeyProjects';
import ArticlesDetail from '@/pages/TurnkeyProjects/Detail';
import AdminArticle from '@/pages/Admin/Article';
import AdminArticleType from '@/pages/Admin/ArticleType';
import News from '@/pages/News';
import NewsDetail from '@/pages/News/Detail';
import AdminNew from '@/pages/Admin/New';
import AdminNewType from '@/pages/Admin/NewType';
import AdminFeedback from '@/pages/Admin/Feedback';

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/',
            component: Home,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/about',
            component: About,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '产品详情',
            path: '/product_xq/:id',
            component: ProductsDetail,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '案例详情',
            path: '/case_details/:id',
            component: ArticlesDetail,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/services',
            component: Services,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/news',
            component: News,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/news_detail/:id',
            component: NewsDetail,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/contact',
            component: Contact,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'products',
            path: '/products',
            component: Products,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
            path: '/turnkey_projects',
            component: TurnkeyProjects,
            meta: {
                topShow: true,
                bottomShow: true,
                wxbar: true,
                toolsbar: false,
                metaInfo: {
                    title: 'CNHONOR GROUP Refrigeration Science And Technology Co,Ltd',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            name: '后台管理端',
            path: '/admin',
            redirect: '/admin/home',
            component: Admin,
            meta: {
                topShow: false,
                bottomShow: false,
                wxbar: false,
                toolsbar: false,
                metaInfo: {
                    title: '后台管理端',
                    keywords: '',
                    description: ''
                }
            },
            children: [
                {
                    name: '产品管理',
                    path: 'home',
                    component: AdminHome,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '产品管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '产品分类管理',
                    path: 'product_type',
                    component: AdminProductType,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '产品分类管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '案例管理',
                    path: 'article',
                    component: AdminArticle,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '案例管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '案例分类管理',
                    path: 'article_type',
                    component: AdminArticleType,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '案例分类管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '新闻管理',
                    path: 'new',
                    component: AdminNew,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '新闻管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '新闻分类管理',
                    path: 'new_type',
                    component: AdminNewType,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '新闻分类管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '反馈管理',
                    path: 'feedback',
                    component: AdminFeedback,
                    meta: {
                        wxbar: false,
                        toolsbar: false,
                        metaInfo: {
                            title: '反馈管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});